window.okeReviewsWidgetOnInit = function () {
    moveAttribute();
}

function moveAttribute() {
    const attributeContainer = document.querySelector('.okeReviews-attributeContainer .okeReviews.okeReviews--theme');
    const attributeBar = document.querySelector('.okeReviews.okeReviews--theme .okeReviews-reviewsAggregate .okeReviews-attributeRatingsTable');
    if (attributeContainer && attributeBar) {
        //Move the aggregate attribute bar inside the attribute container
        attributeContainer.insertAdjacentElement('beforeend', attributeBar);
    }
}